/**
 * This component is a resolver. It is meant to be used by page templates using
 * data from a CMS.
 *
 * You can send the data you receive from the CMS to the props of this components
 * by spreading them (like <Form {...cmsData} />)
 * and then make these props fit the final module.
 *
 * Note that propTypes are not needed in this component: the GraphQL schema
 * definition is sufficient for that matter.
 */
import React from "react"
import { graphql } from "gatsby"
import { Section } from "@bw/bits"
import { Form as FormModule } from "@bw/modules"

const Form = ({
  suptitle,
  title,
  subtitle,
  button,
  buttonPosition,
  form,
  anchor,
}) => {
  if (!form?.handle) {
    return null
  }

  return (
    <Section
      {...{
        suptitle,
        title,
        subtitle,
        button,
        buttonPosition: buttonPosition?.value,
        anchor,
      }}
      containerSize="small"
    >
      <FormModule handle={form.handle} />
    </Section>
  )
}

/**
 * This generates a GraphQL Fragment that can be used in a page query:
 *
 * Example:
 * ... on FormModule {
 *   ...FormModuleFragment
 * }
 *
 * This is also what you will get in the props of your Form
 * resolver component.
 */
export const query = graphql`
  fragment FormModuleFragment on FormModule {
    form {
      api_url
      handle
    }
  }
`

export { Form }
